<template>
  <Table :columns="columns" :data="rows">
    <template #paymentStatus="{ row }">
      <div>
        <FieldSpan
          v-if="row.uncollectible"
          :styleToAdd="getPaymentStatusFieldDisplayStyle('uncollectible')"
          :value="$t('plan_sale_billing.payment_status.uncollectible')"
        />
        <FieldSpan
          v-else
          :styleToAdd="getPaymentStatusFieldDisplayStyle(row.paymentStatus)"
          :value="$t(`plan_sale_billing.payment_status.${row.paymentStatus}`)"
        />
      </div>
    </template>
    <template #invoice="{ row }">
      <div v-if="row.uncollectible === true" class="flex">
        <div class="bg-gray-100 rounded-xl flex px-2 py-1.5">
          <BanIcon class="h-6 w-6 text-gray-800" aria-hidden="true" />
        </div>
      </div>
      <div v-else-if="row.discountApplied" class="flex">
        <GiftIcon class="h-6 w-6 text-primary-dark" aria-hidden="true" />
        <span class="pl-2 text-base font-semibold text-primary-dark">{{ $t("Free") }}</span>
      </div>
      <div v-else-if="row.paymentStatus === 'succeeded'" class="flex">
        <CloudDownloadIcon v-if="row.invoiceUrl" class="h-6 w-6 text-primary-dark cursor-pointer" aria-hidden="true" />
        <a
          v-if="row.invoiceUrl"
          @click.prevent="handleDownload(row)"
          class="pl-2 text-base font-semibold text-primary-dark cursor-pointer"
          target="_blank"
        >
          {{ $t("Download") }}
        </a>
      </div>
      <div v-else-if="['failed', 'disputed'].includes(row.paymentStatus)" class="flex">
        <div class="bg-secondary rounded-xl flex px-2 py-1.5">
          <CreditCardIcon v-if="row.invoicePaymentUrl" class="h-6 w-6 text-black cursor-pointer" aria-hidden="true" />
          <a
            v-if="row.invoicePaymentUrl"
            @click.prevent="handlePayment(row)"
            class="flex items-center pl-2 text-base font-semibold text-black uppercase cursor-pointer"
            target="_blank"
          >
            {{ $t("Pay") }}
          </a>
        </div>
      </div>
      <FieldSpan v-else class="bg-secondary" :value="$t('Available soon')" />
    </template>
  </Table>
</template>

<script>
import { CloudDownloadIcon, GiftIcon, CreditCardIcon, BanIcon } from "@heroicons/vue/outline";
import { Table, FieldSpan, formatPriceTTC } from "@estaly/ui";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    Table,
    FieldSpan,
    CloudDownloadIcon,
    GiftIcon,
    CreditCardIcon,
    BanIcon,
  },

  computed: {
    ...mapGetters("planSaleBillings", ["paymentStatusStyle"]),

    columns() {
      return [
        {
          label: "Numéro de contrat",
          field: "planSaleFriendlyId",
        },
        {
          label: "Montant",
          field: "formattedFinalPrice",
        },
        {
          label: "Statut",
          field: "paymentStatus",
          slot: "paymentStatus",
        },
        {
          label: "Date d'échéance",
          field: "startDate",
        },
        {
          label: "Facture",
          field: "invoiceUrl",
          slot: "invoice",
        },
      ];
    },
    rows() {
      return this.planSaleBillings.map((billing) => ({
        ...billing,
        planSaleFriendlyId: billing.planSale?.friendlyId,
        formattedFinalPrice: formatPriceTTC(billing.finalPrice),
      }));
    },
  },

  props: ["planSaleBillings"],

  methods: {
    ...mapActions("planSaleBillings", ["fetchInvoice"]),

    getPaymentStatusFieldDisplayStyle(paymentStatus) {
      return this.paymentStatusStyle(paymentStatus);
    },

    handleDownload(planSaleBilling) {
      this.fetchInvoice({ planSaleBillingId: planSaleBilling.id })
        .then((response) => {
          const url = response.data.invoiceUrl;
          if (url) window.open(url, "_blank");
        })
        .catch((error) => {
          console.error("Error fetching the invoice URL:", error);
        });
    },

    handlePayment(planSaleBilling) {
      this.fetchInvoice({ planSaleBillingId: planSaleBilling.id })
        .then((response) => {
          const url = response.data.invoicePaymentUrl;
          if (url) window.open(url, "_blank");
        })
        .catch((error) => {
          console.error("Error fetching the payment URL:", error);
        });
    },
  },
};
</script>
